import React from "react";
import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

const DIFFICULTIES = [
  { value: "easy", label: "Easy", stars: 1, colorClass: "text-correct", activeClass: "bg-correct/10 border-correct/20" },
  { value: "medium", label: "Medium", stars: 2, colorClass: "text-warning", activeClass: "bg-warning/10 border-warning/20" },
  { value: "hard", label: "Hard", stars: 3, colorClass: "text-incorrect", activeClass: "bg-incorrect/10 border-incorrect/20" },
];

interface DifficultySelectorProps {
  value: string;
  onChange: (val: string) => void;
}

export const DifficultySelector = ({
  value,
  onChange,
}: DifficultySelectorProps) => {
  return (
    <div className="p-1.5 rounded-2xl border border-primary/20 bg-card w-full">
      <div className="flex items-center gap-2">
        {DIFFICULTIES.map(({ value: diffValue, label, stars, colorClass, activeClass }) => {
          const active = value === diffValue;

          return (
            <button
              key={diffValue}
              type="button"
              onClick={() => onChange(diffValue)}
              className={cn(
                "rounded-xl py-1.5 px-2 text-sm flex items-center gap-1.5 border transition-all duration-200",
                active
                  ? cn(colorClass, activeClass)
                  : "bg-background text-muted-foreground border-secondary/10 hover:border-secondary/50 hover:text-foreground"
              )}
            >
              <span className="flex items-center gap-[2px]">
                {Array.from({ length: stars }).map((_, i) => (
                  <Star key={i} className={cn("w-4 h-4", active && "fill-current")} />
                ))}
              </span>
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
